module.exports = __webpack_public_path__ + "img/采集设备.233d3171.gif";